import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
// branchAgentService.js
import { getBranches } from '@/api/locations/branches';
import { getAgents, getAgentsBranchWise } from '@/api/agents';
import { getAgentsUserById } from '@/api/agents-users';
import { getAdminById } from '@/api/admins';
import { AdminModule } from '@/store/modules/admin';
import { getQuery } from '@/utils';
import { isAdmin, isSuperAdmin } from '@/common';
export const BranchAgentService = {
  async fetchBranches(branchIds = undefined) {
    //  return if branchIds is empty or undefined
    if (Array.isArray(branchIds) && branchIds.length === 0) {
      return []; // Return an empty array or handle as needed
    }
    const query = {
      enabled: true,
      sort: 'name,ASC'
    };
    if (!isSuperAdmin() || !isAdmin()) {
      // Convert array to comma-separated values before passing to getQuery
      query.id = branchIds.length > 1 ? branchIds.join(',') : branchIds;
      query.filter = {
        enabled: 'eq',
        id: '$in'
      };
    }
    return await getBranches(getQuery(query));
  },
  async fetchAgents(branchIds = undefined) {
    if (branchIds === null) {
      return;
    }
    const arrayOfBranchId = Array.isArray(branchIds) ? branchIds : [branchIds];
    try {
      const query = {
        enabled: true,
        sort: 'name,ASC',
        applyBranchIdFilter: true,
        filter: {
          enabled: 'eq'
        }
      };
      if ((!isSuperAdmin() || !isAdmin()) && arrayOfBranchId.length > 0) {
        return await getAgentsBranchWise(getQuery(query));
      } else {
        return await getAgents(getQuery(query));
      }
    } catch (error) {
      // Handle error
    }
  },
  assignBranchId() {
    var _loggedInAdminDetails, _loggedInAdminDetails2;
    const loggedInAdminDetails = AdminModule;
    let branchId = null;
    if (((_loggedInAdminDetails = loggedInAdminDetails.branchIds) === null || _loggedInAdminDetails === void 0 ? void 0 : _loggedInAdminDetails.length) === 1) {
      branchId = loggedInAdminDetails.branchIds[0];
    } else if (((_loggedInAdminDetails2 = loggedInAdminDetails.branchIds) === null || _loggedInAdminDetails2 === void 0 ? void 0 : _loggedInAdminDetails2.length) > 1) {
      branchId = loggedInAdminDetails.branchIds;
    }
    return branchId;
  },
  /**
   * For a Zonal Manager or Branch Manager, resolves branch scope strictly
   * from the admins_branches mapping (Admin.branches relation, via
   * GET /admins/:id) - NOT the broader branchIds normally computed at
   * login, which also folds in dealer-derived and unit-admin-mapped
   * branches. Used by features that specifically need "only branches this
   * admin is explicitly mapped to in admins_branches" (e.g. the Total
   * Stock Value tile/report), without changing the global
   * AdminModule.branchIds scoping every other page relies on.
   *
   * Returns null for every other role (no override - caller should fall
   * back to assignBranchId()). Returns an array for a Zonal/Branch Manager,
   * which may be empty if admins_branches has no rows for them - callers
   * must treat an empty array as "show nothing", not "no filter".
   */
  async resolveExplicitAdminBranches() {
    var _AdminModule$roles, _AdminModule$roles2;
    if (!((_AdminModule$roles = AdminModule.roles) !== null && _AdminModule$roles !== void 0 && _AdminModule$roles.includes('Zonal Manager')) && !((_AdminModule$roles2 = AdminModule.roles) !== null && _AdminModule$roles2 !== void 0 && _AdminModule$roles2.includes('Branch Manager'))) {
      return null;
    }
    try {
      const profile = await getAdminById(AdminModule.id);
      return ((profile === null || profile === void 0 ? void 0 : profile.branches) || []).map(b => b.id);
    } catch (error) {
      return [];
    }
  },
  /**
   * For an Agent session, resolves branch scope strictly from the
   * agents_users_branches mapping (AgentsUser.branches relation, via
   * GET /agents-users/:id) - NOT the broader branchIds normally computed
   * at login, which also folds in dealer-derived branches. Mirrors
   * resolveExplicitAdminBranches() for the Admin side. Used by the Agent
   * dashboard's Total Stock Value tile/report.
   *
   * Branches are mapped per AgentsUser (the individual login user), not
   * per Agent (the parent record) - AdminModule.id holds the AgentsUser id
   * for an Agent session.
   *
   * Returns null when not an Agent session (no override - caller should
   * fall back to assignBranchId()). Returns an array for an Agent, which
   * may be empty if agents_users_branches has no rows for them - callers
   * must treat an empty array as "show nothing", not "no filter".
   */
  async resolveExplicitAgentBranches() {
    if (AdminModule.userType !== 'Agent' || !AdminModule.id) {
      return null;
    }
    try {
      const profile = await getAgentsUserById(AdminModule.id);
      return ((profile === null || profile === void 0 ? void 0 : profile.branches) || []).map(b => b.id);
    } catch (error) {
      return [];
    }
  }
};